import React, { useEffect, useState } from "react";
import withRouter from "components/Common/withRouter";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  FormFeedback,
  Input, // Diğer inputlar için gerekli
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from 'axios';
import { useDispatch } from "react-redux";
import config, { ADMIN_HEADERS } from "../../../config";

const ContactsList = props => {
  document.title = "Bildirim | DLApro Admin PANELI";
  const dispatch = useDispatch();

  const [getCategory, setCategory] = useState([]);
  const [getCategoryID, setCategoryID] = useState(null);
  
  // Varsayılan olarak 'single' seçili gelsin
  const [notificationScope, setNotificationScope] = useState('single');

  const _getAuthData = async () => {
    try {
      const res = await axios.get(`https://dlaviapi.stechomeyazilim.info/Users`, ADMIN_HEADERS);
      setCategory(res.data.value);
    } catch (error) {
      console.error("Kullanıcılar alınamadı:", error);
    }
  };

  useEffect(() => {
    _getAuthData();
  }, []);

  // Radyo butonları değiştiğinde çalışacak fonksiyon
  const handleScopeChange = (e) => {
    setNotificationScope(e.target.value);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      desc: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Lütfen bildirim başlığını giriniz."),
      desc: Yup.string().required("Lütfen bildirim açıklamasını giriniz."),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (notificationScope === 'single' && !getCategoryID) {
        alert('Lütfen bildirim göndermek için bir kullanıcı seçin!');
        return;
      }

      // Artık harici relay yerine dlaviapi OData backend'i (FCM) kullanılıyor.
      // Backend tek kullanıcı için Notification kaydını da kendisi yazar.
      const payload = {
        title: values.title,
        body: values.desc,
        userId: notificationScope === 'single' ? getCategoryID : null, // null => tüm kullanıcılar
      };

      try {
        const endpoint = `${config.AI_BASE}/SendNotification`;
        await axios.post(endpoint, payload, {
          headers: { 'X-API-Key': config.AI_API_KEY },
        });

        alert('Bildirim başarıyla gönderildi!');
        
        // Formu temizle ama state'i koru veya sıfırla
        resetForm();
        setCategoryID(null);
        // İsterseniz scope'u da başa döndürebilirsiniz:
        // setNotificationScope('single'); 

      } catch (error) {
        console.error("Hata:", error);
        alert("Bildirim gönderilirken bir hata oluştu.");
      }
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Bildirim Gönder" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Form onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}>
                    <Row>
                      <Col xs={12}>
                        
                        {/* --- GARANTİ ÇÖZÜM: STANDARD HTML RADIO BUTTONS --- */}
                        <div className="mb-4">
                            <Label className="form-label d-block mb-2 fw-bold">Gönderim Kapsamı</Label>
                            
                            <div className="d-flex align-items-center gap-4">
                                {/* Seçenek 1 */}
                                <div className="form-check">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        name="notificationScope" 
                                        id="scope_single" 
                                        value="single"
                                        checked={notificationScope === 'single'}
                                        onChange={handleScopeChange}
                                        style={{cursor: 'pointer'}}
                                    />
                                    <label className="form-check-label" htmlFor="scope_single" style={{cursor: 'pointer'}}>
                                        Tek Kullanıcıya Gönder
                                    </label>
                                </div>

                                {/* Seçenek 2 */}
                                <div className="form-check">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        name="notificationScope" 
                                        id="scope_all" 
                                        value="all"
                                        checked={notificationScope === 'all'}
                                        onChange={handleScopeChange}
                                        style={{cursor: 'pointer'}}
                                    />
                                    <label className="form-check-label" htmlFor="scope_all" style={{cursor: 'pointer'}}>
                                        Tüm Kullanıcılara Gönder
                                    </label>
                                </div>
                            </div>
                        </div>
                        {/* --- HTML RADIO BUTTONS SONU --- */}


                        {notificationScope === 'single' && (
                          <div className="mb-3">
                            <Label className="form-label">Kullanıcı Seçiniz</Label>
                            <Input
                              name="kullanici"
                              type="select"
                              className="form-select"
                              onChange={(e) => setCategoryID(e.target.value)}
                              value={getCategoryID || ""}
                            >
                              <option value="">Lütfen Seçim Yapınız</option>
                              {getCategory.map((item) => (
                                <option value={item.ID} key={item.ID}>{item.ID} - {item.Users_NameSurname}</option>
                              ))}
                            </Input>
                          </div>
                        )}

                        <div className="mb-3">
                          <Label className="form-label">Bildirim Başlık</Label>
                          <Input
                            name="title"
                            type="text"
                            placeholder="Bildirim Başlık Giriniz"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.title}
                            invalid={validation.touched.title && !!validation.errors.title}
                          />
                           {validation.touched.title && validation.errors.title ? (
                            <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Bildirim Açıklama</Label>
                          <Input
                            name="desc"
                            type="textarea"
                            rows="4"
                            placeholder="Bildirim Açıklama Giriniz"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.desc}
                            invalid={validation.touched.desc && !!validation.errors.desc}
                          />
                           {validation.touched.desc && validation.errors.desc ? (
                            <FormFeedback type="invalid">{validation.errors.desc}</FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end">
                          <button type="submit" className="btn btn-success save-user">
                            BİLDİRİM GÖNDER
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);